module.exports = __webpack_public_path__ + "img/navbg.71066b28.png";